import useBrands from "../../explorer/hooks/useBrands";
import useAppContext from "../../explorer/hooks/useAppContext";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import ServiceProvider from "../configuration/ServiceProvider";
import { BomItemDetails } from "../../explorer/types/SpareParts/BomItemDetails";

const useGoToPage: () => {
    getHomeUrl: () => string;
    goToHome: () => void;
    changeAppContext: (appContext: string) => void;
    changeBrand: (brand: string) => void;

    system: {
        getBasketUrl: () => string;
        goToBasket: () => void;
        getOfferOrderHistoryUrl: () => string;
        goToOfferOrderHistory: () => void;
    };

    spareParts: {
        getHomeUrl: () => string;
        goToHome: () => void;

        getInstalledBaseUrl: (customerSiteCode: string) => string;
        goToInstalledBase: (customerSiteCode: string) => void;

        getSearchUrl: (code: string) => string;
        goToSearch: (code: string) => void;

        getMachineUrl: (customerSiteCode: string, machineId: string, naturalKey?: string) => string;
        goToMachine: (customerSiteCode: string, machineId: string, naturalKey?: string, partCode?: string) => void;

        getMachineMoreUrl: (customerSiteCode: string, machineId: string, tabIndex: string) => string;
        goToMachineMore: (customerSiteCode: string, machineId: string, tabIndex: string) => void;

        getPartDetailsUrl: (partCode: string) => string;
        goToPartDetails: (partCode: string) => void;
    };
} = () => {
    const navigate = useNavigate();
    let [searchParams] = useSearchParams();
    const brand = useBrands().currentBrandUrl;
    const appContext = useAppContext().currentContext;

    const getHomeUrl = () => {
        return `/${appContext}/${brand}${getQueryString([])}`;
    };
    const goToHome = () => {
        navigate(getHomeUrl());
    };
    const changeAppContext = (newAppContext: string) => {
        navigate(`/${newAppContext}/${brand}${getQueryString([])}`);
    }
    const changeBrand = (newBrand: string) => {
        navigate(`/${appContext}/${newBrand}${getQueryString([])}`);
    }

    const getQueryString = (validParams: string[]) => {
        
        validParams.push("lang");
        const params: string[] = [];
        searchParams.forEach((value, key) => {
            params.push(key);
        });

        params.forEach((param) => {
            if (!validParams.includes(param)) {
                searchParams.delete(param);
            }
        });
        return searchParams.size > 0 ? "?" + searchParams.toString() : "";
    };

    const system = {
        getBasketUrl: () => {
            return `/${appContext}/${brand}/basket${getQueryString([])}`;
        },
        goToBasket: () => {
            navigate(system.getBasketUrl());
        },
        getOfferOrderHistoryUrl: () => {
            return `/${appContext}/${brand}/offerOrderHistory${getQueryString([])}`;
        },
        goToOfferOrderHistory: () => {
            navigate(system.getOfferOrderHistoryUrl());
        }
    };
    const spareParts = {
        // per home di spareparts
        getHomeUrl: () => {
            return `/spareparts/${brand}${getQueryString([])}`;
        },
        goToHome: () => {
            navigate(spareParts.getHomeUrl());
        },
        // per la pagina InstalledBase
        getInstalledBaseUrl: (customerSiteCode: string) => {
            return `/spareparts/${brand}/site/${customerSiteCode}/installedbase${getQueryString(
                []
            )}`;
        },
        goToInstalledBase: (customerSiteCode: string) => {
            navigate(spareParts.getInstalledBaseUrl(customerSiteCode));
        },

        // per la pagina search
        getSearchUrl: (code: string) => {
            let _pathParam = encodeURIComponent(code);
            return `/spareparts/${brand}/search/${_pathParam}${getQueryString(
                []
            )}`;
        },
        goToSearch: (code: string) => {
            navigate(spareParts.getSearchUrl(code));
        },

        getMachineUrl: (customerSiteCode: string, machineId: string, naturalKey?: string, partCode?: string) => {
            if (partCode) {
                searchParams.set("partCode", partCode);
            }
            const validParams = partCode ? ["partCode"] : [];
            return `/spareparts/${brand}/site/${customerSiteCode}/machine/${machineId}${naturalKey !== undefined ? "/" + naturalKey : ""}${getQueryString(
                validParams
            )}`;
        },
        goToMachine: (customerSiteCode: string, machineId: string, naturalKey?: string, partCode?: string) => {
            navigate(spareParts.getMachineUrl(customerSiteCode, machineId, naturalKey, partCode));
        },

        getMachineMoreUrl: (customerSiteCode: string, machineId: string, tabIndex: string) => {
            return `/spareparts/${brand}/site/${customerSiteCode}/machine/${machineId}/more/${tabIndex}${getQueryString(
                []
            )}`;
        },
        goToMachineMore: (customerSiteCode: string, machineId: string, tabIndex: string) => {
            navigate(spareParts.getMachineMoreUrl(customerSiteCode, machineId, tabIndex));
        },

        getPartDetailsUrl: (partCode: string) => {
            return `/spareparts/${brand}/partdetails/${partCode}${getQueryString(
                []
            )}`;
        },
        goToPartDetails: (partCode: string) => {
            window.open(spareParts.getPartDetailsUrl(partCode), '_blank');
        }
    };

    return { getHomeUrl, goToHome, changeAppContext, changeBrand, spareParts, system };
};

export default useGoToPage;
